(function(){
  var root=document.querySelector('.lc4');if(!root)return;
  var still=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tabs=[].slice.call(root.querySelectorAll('.lc4-thermo__tabs [role=tab]'));
  function sel(t,focus){
    tabs.forEach(function(x){var on=x===t;x.setAttribute('aria-selected',on?'true':'false');x.tabIndex=on?0:-1;var p=document.getElementById(x.getAttribute('aria-controls'));if(p)p.hidden=!on;});
    root.setAttribute('data-temp',t.getAttribute('data-z'));
    if(focus)t.focus();
  }
  tabs.forEach(function(t,i){
    t.addEventListener('click',function(){sel(t);});
    t.addEventListener('keydown',function(e){var d=e.key==='ArrowRight'?1:e.key==='ArrowLeft'?-1:0;if(!d)return;e.preventDefault();sel(tabs[(i+d+tabs.length)%tabs.length],true);});
  });
  var items=root.querySelectorAll('[data-rv],.lc4-card,.lc4-univ__card,.lc4-rayons__list li');
  if(!still&&'IntersectionObserver' in window){
    items.forEach(function(el){el.setAttribute('data-rv','');var sib=el.parentNode?[].indexOf.call(el.parentNode.children,el):0;el.style.setProperty('--rd',(sib%4)*70+'ms');});
    document.documentElement.classList.add('lc4-ready');
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -6% 0px'});
    items.forEach(function(el){io.observe(el);});
  }
  var tick=false;function sc(){tick=false;root.classList.toggle('is-scrolled',window.scrollY>40);}
  window.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(sc);}},{passive:true});sc();
  var sort=root.querySelector('[data-lc4-sort]');
  if(sort)sort.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',sort.value);u.searchParams.delete('page');location.href=u.toString();});
  var f=root.querySelector('[data-lc4f]');
  if(f){
    f.addEventListener('change',function(e){if(e.target.type==='checkbox')f.submit();});
    if(window.matchMedia('(min-width:1001px)').matches){var w=f.querySelector('[data-lc4f-wrap]');if(w)w.open=true;}
  }
  var k=root.querySelector('[data-lc4k]');
  if(k){var to;k.addEventListener('change',function(e){if(!e.target.hasAttribute('data-lc4k-qty'))return;clearTimeout(to);to=setTimeout(function(){var h=document.createElement('input');h.type='hidden';h.name='update';h.value='1';k.appendChild(h);k.submit();},400);});}
})();